
export const ReclamationStatutEnum = {
  Ouvert: 0,
  EnCours: 1,
  Reaffecte: 2,
  ClotureClient: 3,
  ClotureDefinitive: 4
} as const;
export type ReclamationStatut = (typeof ReclamationStatutEnum)[keyof typeof ReclamationStatutEnum];

export const LitigeGestionCanalEnum = {
    ATC: 1,
    ATCS: 2,
    Magasin: 3,
    Web: 4,
    Rapido: 5,
    Autre: 6
  } as const;  
  export type LitigeGestionCanal = (typeof LitigeGestionCanalEnum)[keyof typeof LitigeGestionCanalEnum];


  export const LitigeGestionEtatEnum = {
    Ouvert: 4,
    EnAttenteDePaiement: 6,
    Clos: 7,
  } as const;  
  export type LitigeGestionEtat = (typeof LitigeGestionEtatEnum)[keyof typeof LitigeGestionEtatEnum];





